// src/config/metrics.ts
const METRICS_CONFIG = {
  development: {
    backendUrl: import.meta.env.VITE_API_URL,
    refreshInterval: 30000, // 30 seconds
  },
  production: {
    backendUrl: import.meta.env.VITE_API_URL,
    refreshInterval: 60000, // 1 minute
  }
};

type Env = 'development' | 'production';

export const getMetricsConfig = () => {
  const env: Env = (import.meta.env.MODE as Env) || 'development';
  return METRICS_CONFIG[env] || METRICS_CONFIG.development;
}; 